"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.abbreviateCurrency = exports.createCurrencyMask = exports.formatCurrency = exports.currencyMaskOptions = void 0;

var _accounting = _interopRequireDefault(require("accounting"));

var _createNumberMask = _interopRequireDefault(require("./utils/createNumberMask"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var prefix = "";
var suffix = "";
var includeThousandsSeparator = true;
var thousandsSeparatorSymbol = "\xA0";
var allowDecimal = true;
var decimalSymbol = ",";
var decimalLimit = 0;
var requireDecimal = false;
var allowNegative = false;
var allowLeadingZeroes = false;
var integerLimit = null;
var currencyMaskOptions = {
  prefix: prefix,
  suffix: suffix,
  includeThousandsSeparator: includeThousandsSeparator,
  thousandsSeparatorSymbol: thousandsSeparatorSymbol,
  allowDecimal: allowDecimal,
  decimalSymbol: decimalSymbol,
  decimalLimit: decimalLimit,
  requireDecimal: requireDecimal,
  allowNegative: allowNegative,
  allowLeadingZeroes: allowLeadingZeroes,
  integerLimit: integerLimit
};
exports.currencyMaskOptions = currencyMaskOptions;
var format = "%v%s";
var currencyOptions = {
  symbol: suffix,
  precision: decimalLimit,
  thousand: thousandsSeparatorSymbol,
  decimal: decimalSymbol,
  format: format
};

var formatCurrency = function formatCurrency(number) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (typeof number !== "number") {
    throw new TypeError("Expected a number, got ".concat(_typeof(number)));
  }

  var opts = _objectSpread({}, currencyOptions, options);

  var symbol = opts.symbol,
      precision = opts.precision,
      thousand = opts.thousand,
      decimal = opts.decimal,
      format = opts.format;
  return _accounting["default"].formatMoney(number, symbol, precision, thousand, decimal, format);
};

exports.formatCurrency = formatCurrency;

var createCurrencyMask = function createCurrencyMask() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  options = Object.assign({}, currencyMaskOptions, options);
  return (0, _createNumberMask["default"])(options);
};

exports.createCurrencyMask = createCurrencyMask;

var abbreviateCurrency = function abbreviateCurrency(value) {
  var newValue = value;

  if (value >= 1000) {
    var suffixes = ["", "k", "m", "b", "t"];
    var suffixNum = Math.floor(("" + value).length / 3);
    var shortValue = "";

    for (var precision = 2; precision >= 1; precision--) {
      shortValue = parseFloat((suffixNum !== 0 ? value / Math.pow(1000, suffixNum) : value).toPrecision(precision));
      var dotLessShortValue = (shortValue + "").replace(/[^a-zA-Z 0-9]+/g, "");

      if (dotLessShortValue.length <= 2) {
        break;
      }
    }

    if (shortValue % 1 != 0) shortValue = shortValue.toFixed(1);
    newValue = shortValue + suffixes[suffixNum];
  }

  return newValue;
};

exports.abbreviateCurrency = abbreviateCurrency;